import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { appRoutePaths } from '../../components/Root/navigation';
import { apiDocsRootRouteRef } from './routes';

const apiDocsPageLoader = () =>
  import('../../components/api/CustomApiExplorerPage').then(module => (
    <module.CustomApiExplorerPage />
  ));

const apiDocsPage = PageBlueprint.make({
  name: 'driveline-explorer',
  params: {
    path: appRoutePaths.apis,
    routeRef: apiDocsRootRouteRef,
    noHeader: true,
    loader: apiDocsPageLoader,
  },
});

const apiDocsAliasPage = PageBlueprint.make({
  name: 'driveline-explorer-apis-alias',
  params: {
    path: '/apis',
    noHeader: true,
    loader: apiDocsPageLoader,
  },
});

export const apiDocsPageModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [apiDocsPage, apiDocsAliasPage],
});
